import { render, staticRenderFns } from "./ProfileDocumentsCard.vue?vue&type=template&id=3b3e6728"
import script from "./ProfileDocumentsCard.vue?vue&type=script&lang=js"
export * from "./ProfileDocumentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports